'use strict';

export default {
  formAdmin: {
    addFieldWhenNoSections: "Veuillez ajouter une section dans cette étape avant d'ajouter des champs",
    save: ' Sauvegarder',
    preview: ' Prévisualiser',
    lock: ' Verrouiller',
    fields: 'Ajouter Champs',
    properties: 'Propriétés',
    addButton: 'Ajouter une option',
    enablePaymentError: 'Veuillez activer le paiement pour ce formulaire',
    noPaymentAccounts: 'Créez un compte de paiement Stripe pour utiliser les fonctionnalités de paiement',
    paymentModesError:
      "Une erreur est survenue avec les modes de paiement. Veuillez vérifier votre configuration dans l'onglet paiement",
    editFormProperties: 'Propriétés du formulaire',
    choiceOptions: 'Options de choix',
    paymentOptions: 'Options de paiement',
    discountCodesError:
      "Une erreur est survenue avec les codes de réduction. Veuillez vérifier votre configuration dans l'onglet paiement",
    deleteLanguageConfirmation: `Êtes-vous sûr de vouloir supprimer la traduction {language, select, 
                                                     fr { française } 
                                                     en { anglaise }
                                                     other {}
                                                     } de ce formulaire?`,
    languageWarning:
      'Certains textes ont été modifiés dans une langue, mais pas dans les autres. Êtes-vous sûr de vouloir continuer sans les modifier?',
  },
};
